<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import url("assets/css/font.css");

#app {
  font-family: 'Roboto Regular' !important;
}

.medium-font {
    font-family: 'Roboto Medium';
}
</style>



// WEBPACK FOOTER //
// src/App.vue